import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import type {Vec3} from '../types/global';

export type InteractionMode = 'orbit' | 'pan';

export interface ViewerState {
  interactionMode: InteractionMode;
  showGrid: boolean;
  showWireframe: boolean;
  showRTLSMarkers: boolean;
  showLabels: boolean;
  performanceMode: boolean;
  cameraPosition: Vec3 | null;
  cameraTarget: Vec3 | null;
  fps: number;
  sceneReady: boolean;
}

const initialState: ViewerState = {
  interactionMode: 'orbit',
  showGrid: false,
  showWireframe: false,
  showRTLSMarkers: true,
  showLabels: true,
  performanceMode: false,
  cameraPosition: null,
  cameraTarget: null,
  fps: 0,
  sceneReady: false,
};

const viewerSlice = createSlice({
  name: 'viewer',
  initialState,
  reducers: {
    setInteractionMode(state, action: PayloadAction<InteractionMode>) {
      state.interactionMode = action.payload;
    },
    toggleGrid(state) {
      state.showGrid = !state.showGrid;
    },
    toggleWireframe(state) {
      state.showWireframe = !state.showWireframe;
    },
    toggleRTLSMarkers(state) {
      state.showRTLSMarkers = !state.showRTLSMarkers;
    },
    toggleLabels(state) {
      state.showLabels = !state.showLabels;
    },
    togglePerformanceMode(state) {
      state.performanceMode = !state.performanceMode;
    },
    setCameraState(
      state,
      action: PayloadAction<{position: Vec3; target: Vec3}>,
    ) {
      state.cameraPosition = action.payload.position;
      state.cameraTarget = action.payload.target;
    },
    setFps(state, action: PayloadAction<number>) {
      state.fps = action.payload;
    },
    setSceneReady(state, action: PayloadAction<boolean>) {
      state.sceneReady = action.payload;
    },
  },
});

export const viewerActions = viewerSlice.actions;
export default viewerSlice.reducer;
